import React,{ Component } from "react";
import { connect } from "react-redux";
import { Row, Col,  Card, CardHeader, Container} from "reactstrap";
import ApiForm from "../ApiForm/ApiForm";
import Proptypes from "prop-types";
import {updateApiConfigs} from "../../../actions/actionDevloper";

class UpdateApi extends Component{
    render(){
        return (
            <div className="mt-4">
                <Row>
                    <Container>
                        <Col sm={{ size: 8, order: 3, offset: 2 }}>
                            <Card className="user-form-container" >
                                <CardHeader>
                                    <i className="fa fa-edit"></i> <strong>Update Api</strong>
                                </CardHeader>
                                <ApiForm
                                    updateApi={this.props.updateApiConfigs}
                                    apiId={this.props.match.params.id}
                                    fromUpdate={true}
                                />
                            </Card>
                        </Col>
                    </Container>
                </Row>
            </div>
        );
    }
}

UpdateApi.propTypes = {
    updateApiConfigs: Proptypes.func.isRequired,
    match: Proptypes.object
};

export default connect(state => ({
        apis: state.develop.apis || []
    }),
    dispatch => ({
        updateApiConfigs: (data) => dispatch(updateApiConfigs(data))
    }))(UpdateApi);